export default __webpack_public_path__ + "static/media/dashboard-social.4b329733.jpg";